"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showSpreedlyModal = showSpreedlyModal;
exports.init = void 0;

var _paymentHelpers = require("./paymentHelpers");

var _genericValidation = require("../global/utils/genericValidation");

var _SpreedlyExpressFormModule = _interopRequireDefault(require("./SpreedlyExpressForm.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
 * This style tag should only be loaded in components where it's used
 * else there is some chance it could override other global styles
 *
 * The Spreedly modal has a different orientation on
 * screens in landscape up to 480px wide (mebile devices)
 *
 * See the spreedly-overrides.css file for code that isn't minified
 * If you make changes to that file be sure to minify and copy here
 */
function addSpreedlyStyleTag() {
  var hasStyleTag = document.querySelector('style[data-spreedly-overrides="true"]') !== null;
  if (hasStyleTag) return;
  var styleTag = document.createElement('style');
  styleTag.dataset.spreedlyOverrides = 'true';
  styleTag.innerText = "@media screen and (max-width:480px){div.spreedly-fields-holder{height:auto}fieldset.spreedly-fs-name{height:auto}fieldset.spreedly-fs-cc{height:auto}fieldset.spreedly-fs-cc .spreedly-field{height:auto;padding:5px 5px 5px 16px}label.spreedly-label{width:65px}div#spreedly-number{max-width:200px;padding:12px 12px 10px 10px;border:2px solid transparent}fieldset.spreedly-fs-cc div.spreedly-field input#spreedly-exp-month,fieldset.spreedly-fs-cc div.spreedly-field input#spreedly-exp-year,fieldset.spreedly-fs-name div.spreedly-field input#spreedly-name{height:auto;padding:12px;font-size:16px}fieldset.spreedly-fs-cc div.spreedly-field input#spreedly-exp-month,fieldset.spreedly-fs-cc div.spreedly-field input#spreedly-exp-year{position:relative;padding-right:5px;padding-left:5px;max-width:40px;font-variant-numeric:tabular-nums;letter-spacing:2px;text-align:center}fieldset.spreedly-fs-cc div.spreedly-field input#spreedly-exp-month{margin-left:5px}fieldset.spreedly-fs-cc div.spreedly-field input#spreedly-exp-year{margin-left:3px}fieldset.spreedly-fs-cc div.spreedly-field input#spreedly-exp-month::placeholder,fieldset.spreedly-fs-cc div.spreedly-field input#spreedly-exp-year::placeholder{letter-spacing:1px}fieldset.spreedly-fs-cc div.spreedly-field input#spreedly-exp-month:focus,fieldset.spreedly-fs-cc div.spreedly-field input#spreedly-exp-year:focus,fieldset.spreedly-fs-name div.spreedly-field input#spreedly-name:focus{outline-color:#97cdff!important}fieldset.spreedly-fs-cc div.spreedly-field i.spreedly-icon-cc{right:55px}div#spreedly-cvv{padding:12px 12px 10px 10px;border:2px solid transparent}div.spreedly-field i.spreedly-icon-validation{margin-top:-8px}div.spreedly-field i.spreedly-icon-cc{margin-top:4px}#spreedly-submit-button{padding:0;font-size:18px}}@media screen and (min-width:481px){.container{height:calc(100% + 2px)!important}}";
  document.head.append(styleTag);
}

function hasSpreedlyExpressScriptTag(source) {
  var spreedlyScript = document.querySelector("script[src=\"".concat(source, "\"]"));
  return !!spreedlyScript;
}

function hasSpreedlyExpressObjs() {
  var hasSpreedlyObj = _typeof(window.Spreedly) === 'object';
  var hasSpreedlyExpressObj = _typeof(window.SpreedlyExpress) === 'object';
  return hasSpreedlyObj && hasSpreedlyExpressObj;
}

function spreedlyExpressIsLoaded() {
  var _window, _window$Spreedly, _window2, _window2$SpreedlyExpr, _window3, _window3$SpreedlyExpr, _window$Spreedly$isLo, _window4, _window4$Spreedly;

  var sourceIsExpress = ((_window = window) === null || _window === void 0 ? void 0 : (_window$Spreedly = _window.Spreedly) === null || _window$Spreedly === void 0 ? void 0 : _window$Spreedly.source) === 'express';
  var hasOptions = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$SpreedlyExpr = _window2.SpreedlyExpress) === null || _window2$SpreedlyExpr === void 0 ? void 0 : _window2$SpreedlyExpr.initialOptions) ? JSON.stringify((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$SpreedlyExpr = _window3.SpreedlyExpress) === null || _window3$SpreedlyExpr === void 0 ? void 0 : _window3$SpreedlyExpr.initialOptions) !== '{}' : false;
  var formIsLoaded = (_window$Spreedly$isLo = (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$Spreedly = _window4.Spreedly) === null || _window4$Spreedly === void 0 ? void 0 : _window4$Spreedly.isLoaded()) !== null && _window$Spreedly$isLo !== void 0 ? _window$Spreedly$isLo : false;
  return sourceIsExpress && hasOptions && formIsLoaded;
} // Defensive programming


function spreedlyExpressCanLoad(args) {
  var formType = args.formType,
      spreedlyEnvironmentKey = args.spreedlyEnvironmentKey,
      total = args.total,
      practiceName = args.practiceName,
      fullName = args.fullName,
      spreedlyTokenSuccessHandler = args.spreedlyTokenSuccessHandler,
      spreedlyScriptLoadErrorHandler = args.spreedlyScriptLoadErrorHandler,
      spreedlyCloseHandler = args.spreedlyCloseHandler;
  var validationObj = {
    formType: formType === _paymentHelpers.formTypes.spreedly,
    spreedlyEnvironmentKey: (0, _genericValidation.isNonEmptyString)(spreedlyEnvironmentKey),
    total: (0, _genericValidation.isNonEmptyString)(total),
    practiceName: (0, _genericValidation.isNonEmptyString)(practiceName),
    fullName: (0, _genericValidation.isNonEmptyString)(fullName),
    spreedlyTokenSuccessHandler: (0, _genericValidation.isFunction)(spreedlyTokenSuccessHandler),
    spreedlyScriptLoadErrorHandler: (0, _genericValidation.isFunction)(spreedlyScriptLoadErrorHandler),
    spreedlyCloseHandler: (0, _genericValidation.isFunction)(spreedlyCloseHandler)
  };
  return Object.values(validationObj).every(function (bool) {
    return bool;
  });
}

function makeSpreedlyExpressScriptTag(source) {
  var script = document.createElement('script');
  script.src = source;
  script.async = true;
  script.SameSite = 'None';
  script.Secure = true;
  return script;
} // function removeSpreedlyExpressScriptTag(source) {
//   const scriptTag = document.querySelector(`script[src="${source}"]`);
//   if (scriptTag) {
//     const parent = scriptTag?.parentElement;
//     parent?.removeChild(scriptTag);
//   }
// }


function showSpreedlyModal() {
  var _window5, _window5$SpreedlyExpr;

  (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$SpreedlyExpr = _window5.SpreedlyExpress) === null || _window5$SpreedlyExpr === void 0 ? void 0 : _window5$SpreedlyExpr.openView();
}

function setSpreedlyStyles() {
  window.Spreedly.setStyle('number', 'padding-left: 0; border: none; outline: none; font-size: 16px;');
  window.Spreedly.setStyle('cvv', 'padding-left: 0; border: none; outline: none; font-size: 16px;');
}

function handleSpreedlyFieldEvent(name, type) {
  var parentEl = null;

  switch (name) {
    case 'number':
      parentEl = document.getElementById('spreedly-number');
      break;

    case 'cvv':
      parentEl = document.getElementById('spreedly-cvv');
      break;

    default:
      break;
  }

  if (!parentEl) return;

  if (type === 'focus') {
    var _styles$focusSpreedly;

    parentEl.classList.add((_styles$focusSpreedly = _SpreedlyExpressFormModule.default === null || _SpreedlyExpressFormModule.default === void 0 ? void 0 : _SpreedlyExpressFormModule.default.focusSpreedlyParent) !== null && _styles$focusSpreedly !== void 0 ? _styles$focusSpreedly : '');
  } else if (type === 'blur') {
    var _styles$focusSpreedly2;

    parentEl.classList.remove((_styles$focusSpreedly2 = _SpreedlyExpressFormModule.default === null || _SpreedlyExpressFormModule.default === void 0 ? void 0 : _SpreedlyExpressFormModule.default.focusSpreedlyParent) !== null && _styles$focusSpreedly2 !== void 0 ? _styles$focusSpreedly2 : '');
  }
}

function afterSpreedlyInit(args) {
  var PRIVATE_SET_IS_LOADING = args.PRIVATE_SET_IS_LOADING,
      handleSpreedlyLoaded = args.handleSpreedlyLoaded;
  setSpreedlyStyles();
  window.Spreedly.on('fieldEvent', function (name, type) {
    return handleSpreedlyFieldEvent(name, type);
  }); // const spreedlyCloseButton = document.getElementById('spreedly-close-button');

  var spreedlySubmitButton = document.getElementById('spreedly-submit-button');

  if (spreedlySubmitButton) {
    spreedlySubmitButton.style.backgroundColor = '#FF9933';
  }

  window.Spreedly.setPlaceholder('number', 'XXXX XXXX XXXX XXXX');
  handleSpreedlyLoaded();
  PRIVATE_SET_IS_LOADING(false);
}

function loadSpreedlyForm(args) {
  var spreedlyEnvironmentKey = args.spreedlyEnvironmentKey,
      total = args.total,
      practiceName = args.practiceName,
      invoiceId = args.invoiceId,
      fullName = args.fullName,
      spreedlyTokenSuccessHandler = args.spreedlyTokenSuccessHandler,
      spreedlyCloseHandler = args.spreedlyCloseHandler; // Remove old form if it exists

  var modalEl = document.querySelector('#spreedly-modal-overlay');
  var parentEl = modalEl !== null ? modalEl.parentElement : null;

  if (modalEl !== null && parentEl !== null) {
    parentEl.removeChild(modalEl);
  }

  window.SpreedlyExpress.init(spreedlyEnvironmentKey, {
    amount: "$ ".concat(total),
    company_name: "".concat(practiceName),
    sidebar_top_description: "".concat(invoiceId),
    sidebar_bottom_description: 'Total Amount',
    full_name: "".concat(fullName)
  });
  window.SpreedlyExpress.onInit(function () {
    return afterSpreedlyInit(args);
  });
  window.SpreedlyExpress.onPaymentMethod(function (token, paymentMethod) {
    spreedlyTokenSuccessHandler(token, paymentMethod);
    /**
     * 12/1/2020
     * When the form is submitted the token / payment method are saved in SpreedlyExpress
     * so that if we try to redirect the user back to the form it will use the saved
     * token to try and resubmit the payment
     *
     * IDK why they decided to do this but if you console.log(window.SpreedlyExpress.openView)
     * you will see this:
     *  p = function() {
     *        if (n.token)
     *          n.returnToken();
     *        else {
     *          s.setConfiguration();
     *          ...
     *        }
     *          ...
     *      }
     *
     * Effectively what this means is that we have to reset the form, which is what the
     * next two lines do
     *
     * It would have been preferable to use the window.SpreedlyExpress.reset method
     * with the 'ready' event but I couldn't get it to work and the documentation
     * wasn't helpful
     */

    window.SpreedlyExpress.reload();
    loadSpreedlyForm(args);
  });
  window.SpreedlyExpress.onViewClose(function () {
    spreedlyCloseHandler();
    /**
     * For whatever reason the name field keeps getting reset to nothing when
     * the close button is clicked, but we can set it again using setDisplayOptions
     */

    window.SpreedlyExpress.setDisplayOptions({
      full_name: "".concat(fullName)
    });
  });
  /**
   * Using the any type is generally frowned upon but TS is being a pain here
   * we have a typeguard below to ensure that the element exists
   */

  var spreedlyNameField = document.getElementById('spreedly-name');
  if (spreedlyNameField) spreedlyNameField.value = fullName;
}

function initSpreedlyExpress(args) {
  var scriptTag = args.scriptTag,
      spreedlyScriptLoadErrorHandler = args.spreedlyScriptLoadErrorHandler;

  if (scriptTag) {
    scriptTag.onload = function () {
      loadSpreedlyForm(args);
    }; // this is not really the token error handler...


    scriptTag.onerror = function (err) {
      console.log(err);

      if (typeof spreedlyScriptLoadErrorHandler === 'function') {
        spreedlyScriptLoadErrorHandler(err);
      }
    };

    document.body.appendChild(scriptTag);
  } else {
    loadSpreedlyForm(args);
  }
}
/**
 * This IIFE creates a closure which effectively allows for private variables in vanilla JS
 * Yes, it is possible to create private methods in a TS Class
 * No I don't like using Classes and I'm developing this this solo so... ¯\_(ツ)_/¯
 *
 * Anyway, the idea here is not to call init again if we're in the middle of initializing already
 */


var init = function () {
  var PRIVATE_IS_LOADING = false;

  var PRIVATE_SET_IS_LOADING = function PRIVATE_SET_IS_LOADING(val) {
    return PRIVATE_IS_LOADING = val;
  };

  return function (args) {
    var spreedlyLoadingStartHandler = args.spreedlyLoadingStartHandler; // internal function state, nothing to do with react

    var state = {
      scriptTag: null,
      scriptSource: 'https://core.spreedly.com/iframe/express-2.min.js'
    };
    var hasSpreedlyExpress = hasSpreedlyExpressScriptTag(state.scriptSource) && hasSpreedlyExpressObjs();
    if (!hasSpreedlyExpress) state.scriptTag = makeSpreedlyExpressScriptTag(state.scriptSource);
    var expressIsLoaded = spreedlyExpressIsLoaded();
    var expressCanLoad = spreedlyExpressCanLoad(args);

    if (!PRIVATE_IS_LOADING && !expressIsLoaded && expressCanLoad) {
      PRIVATE_SET_IS_LOADING(true);
      if (typeof spreedlyLoadingStartHandler === 'function') spreedlyLoadingStartHandler();
      initSpreedlyExpress(_objectSpread(_objectSpread({}, args), {}, {
        scriptTag: state.scriptTag,
        PRIVATE_SET_IS_LOADING: PRIVATE_SET_IS_LOADING
      }));
      addSpreedlyStyleTag();
    }
  };
}();

exports.init = init;